import gql from 'graphql-tag'

export const variant = gql`
  fragment Variant on ProductVariant {
    availableForSale
    id
    title
    image {
      transformedSrc(maxWidth: 190)
    }
    selectedOptions {
      name
      value
    }
    priceV2 {
      amount
    }
    quantityAvailable
    product {
      id
    }
    sku
    weight
    weightUnit
    inventoryType: metafield(namespace: "inventory", key: "INVENTORY_TYPE_NEW") {
      value
    }
    preOrderShippingDate: metafield(namespace: "inventory", key: "PRE_ORDER_SHIPPING_DATE_NEW") {
      value
    }
    inventoryTypeLowerCase: metafield(namespace: "inventory", key: "inventory_type") {
      value
    }
    preOrderShippingDateLowerCase: metafield(namespace: "inventory", key: "pre_order_shipping_date") {
      value
    }
  }
`

export const discount = gql`
  fragment Discount on DiscountAllocation {
    allocatedAmount {
      amount
    }
    discountApplication {
      allocationMethod
      targetSelection
      targetType
      __typename
      ... on ScriptDiscountApplication {
        title
      }
      ... on AutomaticDiscountApplication {
        title
      }
      ... on ManualDiscountApplication {
        title
      }
      ... on DiscountCodeApplication {
        title: code
      }
    }
  }
`

export const checkout = gql`
  fragment ShopifyCheckout on Checkout {
    id
    subtotalPriceV2 {
      amount
    }
    lineItemsSubtotalPrice {
      amount
    }
    discountApplications(first: 10) {
      edges {
        node {
          ... on DiscountCodeApplication {
            code
          }
        }
      }
    }
    lineItems(first: 250) {
      edges {
        node {
          id
          title
          customAttributes {
            key
            value
          }
          quantity
          variant {
            ...Variant
          }
          discountAllocations {
            ...Discount
          }
        }
      }
    }
    orderStatusUrl
    webUrl
  }
  ${variant}
  ${discount}
`
